import { css, CSSResult } from 'lit'

export const style: CSSResult = css`
  cse-link {
    --cse-link-text-align: left;
  }
`
